import { TeamMemberDto } from '@tallo/investor/company';

// Declared in showing-agents because this lib depends on it, not the reverse, and both libs' team calls take it
export type { TeamSubject } from '@tallo/investor/showing-agents';

export interface PropertyTeamCollaboratorDto extends TeamMemberDto {
  /** Added through the portfolio, so they also join every unit filed into it later */
  joinsNewUnits: boolean;
}

/** A colleague who can view the unit waiting to work on it */
export interface PropertyAccessRequestDto {
  id: string;
  requester: TeamMemberDto;
  createdAt: string;
}

/** A request waiting on the caller, with the unit it is about */
export interface AccessRequestToAnswerDto extends PropertyAccessRequestDto {
  property: { id: string; displayName: string; coverImage: string | null };
}

/** The caller's own open request to work on the unit */
export interface OwnAccessRequestDto {
  id: string;
  createdAt: string;
}

/** Who listing sites show for the unit, and where that comes from */
export interface ListingContactDto {
  /** The seat its portfolio names, or else its manager */
  contact: TeamMemberDto | null;
  setOnPortfolio: boolean;
  /** Off when the company's listings go out as Tallo with Emily as the contact */
  shownOnListings: boolean;
}

/** Who works one unit, and which of its team controls the caller may use. */
export interface PropertyTeamDto {
  propertyId: string;
  /** Missing only when the manager's seat has been removed */
  manager?: TeamMemberDto | null;
  portfolio: { id: string; name: string; owner?: TeamMemberDto | null } | null;
  listingContact: ListingContactDto;
  collaborators: PropertyTeamCollaboratorDto[];
  /** The caller works this unit: may change it and speak for it */
  canManage: boolean;
  canHandOff: boolean;
  canEditCollaborators: boolean;
  canMove: boolean;
  /** Only for a caller who may add collaborators */
  accessRequests: PropertyAccessRequestDto[];
  myAccessRequest: OwnAccessRequestDto | null;
}

export interface BuildingTeamDto extends Omit<PropertyTeamDto, 'propertyId'> {
  buildingId: string;
}

export type TeamDto = PropertyTeamDto | BuildingTeamDto;

/** The backend's refusal of a change to a unit or building the caller can view but does not work; it names which */
export const propertyAccessRequiredErrorCode = 'PROPERTY_ACCESS_REQUIRED';
